import React from 'react';
import HRRequestsPage from '../../pages/payroll-section/requests';
import ProtectedRoute from '../protected';

export const HRRequestRoutes = [
  <ProtectedRoute exact path='/requests' component={HRRequestsPage} />,
];